import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/gbhome.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta:{
      title:"首页"
    },
  },{
    path: "/gbzntyj",
    name: "gbzntyj",
    meta:{
      title:"项目总览"
    },
    component: () =>
      import( "../views/gbzntyj.vue"),
  },{
    path: "/plant",
    name: "plant",
    meta:{
      title:"项目概况"
    },
    component: () =>
      import( "../views/Plant.vue"),
  },{
    path: "/gbzntjs",
    name: "gbzntjs",
    meta:{
      title:"项目进度"
    },
    component: () =>
      import( "../views/gbzntjs.vue"),
  },{
    path: "/zuowufenxi",
    name: "zuowufenxi",
    meta:{
      title:"作物分析"
    },
    component: () =>
      import( "../views/Zuowufenxi.vue"),
  },{
    path: "/zhinengGG",
    name: "zhinengGG",
    meta:{
      title:"智能灌溉"
    },
    component: () =>
      import( "../views/ZhinengGG.vue"),
  },{
    path: "/binghai",
    name: "binghai",
    meta:{
      title:"病虫害管理"
    },
    component: () =>
      import( "../views/Binghai.vue"),
  },{
    path: "/plantmoxing",
    name: "plantmoxing",
    meta:{
      title:"种植模型"
    },
    component: () =>
      import( "../views/Plantmoxing.vue"),
  },{
    path: "/suyuan",
    name: "suyuan",
    meta:{
      title:"农业溯源"
    },
    component: () =>
      import( "../views/Sunyuan.vue"),
  },{
    path: "/qihouYj",
    name: "qihouYj",
    meta:{
      title:"气候灾害预警"
    },
    component: () =>
      import( "../views/QihouYj.vue"),
  }
  ,{
    path: "/plantfx1",
    name: "plantfx1",
    meta:{
      title:"小麦分析-上蔡"
    },
    component: () =>
      import( "../views/Plantfx1.vue"),
  },{
    path: "/xuntian",
    name: "xuntian",
    meta:{
      title:"巡田管理"
    },
    component: () =>
      import( "../views/Xuntian.vue"),
  },{
    path: "/huanjing",
    name: "huanjing",
    meta:{
      title:"生态环境"
    },
    component: () =>
      import( "../views/Huangjing.vue"),
  },{
    path: "/shuijia",
    name: "shuijia",
    meta:{
      title:"水价改革"
    },
    component: () =>
      import( "../views/Shuijia.vue"),
  },{
    path: "/datajc",
    name: "datajc",
    meta:{
      title:"数据监测"
    },
    component: () =>
      import( "../views/Datajc.vue"),
  },
  {
    path: "/sanchanrh",
    name: "sanchanrh",
    meta:{
      title:"三产融合"
    },
    component: () =>
      import( "../views/sanchanrh.vue"),
  },{
    path: "/plantfx",
    name: "plantfx",
    meta:{
      title:"全球小麦分析"
    },
    component: () =>
      import( "../views/plantfx.vue"),
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
